export const SHORT_TRANSLATION_KEY = true;
export const LONG_TRANSLATION_KEY = false;
